// import { login, logout, getInfo } from '@/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'
// import { getBaseUrl } from '@/utils/env'

const user = {
  state: {
    // token: getToken(),
    u_name: '',
    u_id: null,
    roles: [],
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, u_name) => {
      state.u_name = u_name
    },
    SET_UID: (state, u_id) => {
      state.u_id = u_id
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

//   actions: {
//     // 登录
//     Login({ commit }, userInfo) {
//       const username = userInfo.username.trim()
//       const password = userInfo.password
//       const code = userInfo.code
//       const uuid = userInfo.uuid
//       return new Promise((resolve, reject) => {
//         login(username, password, code, uuid).then(res => {
//           setToken(res.token)
//           commit('SET_TOKEN', res.token)
//           resolve()
//         }).catch(error => {
//           reject(error)
//         })
//       })
//     },

//     // 获取用户信息
//     GetInfo({ commit, state }) {
//       return new Promise((resolve, reject) => {
//         getInfo(state.token).then(res => {
//           const user = res.user
//           const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : getBaseUrl() + user.avatar;
//           if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
//             commit('SET_ROLES', res.roles)
//             commit('SET_PERMISSIONS', res.permissions)
//           } else {
//             commit('SET_ROLES', ['ROLE_DEFAULT'])
//           }
//           commit('SET_NAME', user.userName)
//           commit('SET_AVATAR', avatar)
//           resolve(res)
//         }).catch(error => {
//           reject(error)
//         })
//       })
//     },

//     // 退出系统
//     LogOut({ commit, state }) {
//       return new Promise((resolve, reject) => {
//         logout(state.token).then(() => {
//           commit('SET_TOKEN', '')
//           commit('SET_ROLES', [])
//           commit('SET_PERMISSIONS', [])
//           removeToken()
//           resolve()
//         }).catch(error => {
//           reject(error)
//         })
//       })
//     },

//     // 前端 登出
//     FedLogOut({ commit }) {
//       return new Promise(resolve => {
//         commit('SET_TOKEN', '')
//         removeToken()
//         resolve()
//       })
//     }
//   }
}

export default user
